/**
 * Stormforge Keyboard Listener Component
 * Listens for STORMFORGE keyboard sequence to activate easter egg
 */

import { useStormforgeMode } from '@/hooks/useStormforgeMode';

export function StormforgeListener() {
  // Hook handles all keyboard logic
  useStormforgeMode();
  return null;
}
